import { Component } from '@angular/core';

@Component({
    template: '<router-outlet></router-outlet>'
})
export class AccountsComponent {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/accounts/accounts.component.ts